import axios from 'axios'
import qs from 'qs'

export const getDevice = params => { return axios.get(`/client/device/${params.id}`, { params: params }) }
export const createOrder = params => { return axios.post(`/client/device/order`, params) }
export const getOrder = params => { return axios.get(`/client/device/order/${params.id}`) }
export const payOrder = params => { return axios.post(`/client/device/order/pay`, params) }
export const payStatus = params => { return axios.post(`/client/device/order/pay/status?paymentId=${params.paymentId}`, params) }



// WEBPACK FOOTER //
// ./src/services/api/client/index.js